"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentProductAllOfAplusToJSON = exports.ShipmentProductAllOfAplusFromJSONTyped = exports.ShipmentProductAllOfAplusFromJSON = void 0;
var _1 = require("./");
function ShipmentProductAllOfAplusFromJSON(json) {
    return ShipmentProductAllOfAplusFromJSONTyped(json, false);
}
exports.ShipmentProductAllOfAplusFromJSON = ShipmentProductAllOfAplusFromJSON;
function ShipmentProductAllOfAplusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'iconUrl': json['iconUrl'],
        'isIncluded': json['isIncluded'],
        'price': (0, _1.AmountFromJSON)(json['price']),
    };
}
exports.ShipmentProductAllOfAplusFromJSONTyped = ShipmentProductAllOfAplusFromJSONTyped;
function ShipmentProductAllOfAplusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'iconUrl': value.iconUrl,
        'isIncluded': value.isIncluded,
        'price': (0, _1.AmountToJSON)(value.price),
    };
}
exports.ShipmentProductAllOfAplusToJSON = ShipmentProductAllOfAplusToJSON;
//# sourceMappingURL=ShipmentProductAllOfAplus.js.map